import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../models/State"
import {fetchSearchCategoryThumbnailsThunk} from "../../ducks/search"

const getSearchItems = (state: State) => state.search.items
const getSearchFacets = (state: State) => state.search.facets

export const mapStateToProps = (state: State) => {
    // If filters are present with no items we are working on the client side
    // If there are no filters then it means the initial SS API call to fetch the filters returned no items

    const getNoResults = createSelector(
        [getSearchItems, getSearchFacets],
        (items, facets) => items?.length <= 0 && Object.entries(facets).length <= 0,
    )

    // If filters are present with no items we are working on the client side
    // If there are no filters then it means the initial SS API call to fetch the filters returned no items
    const noResults = getNoResults(state)
    const {template} = state
    const {pageSizeLimit, relaxedQuery} = state.search
    return {
        noResults,
        templating: template,
        pageSizeLimit,
        relaxedQuery,
    }
}
const mapDispatchToProps = {
    fetchSearchCategoryThumbnailsThunk,
}
export default connect(mapStateToProps, mapDispatchToProps)
